const setResolution = (device, size) => (dispatch) => 
    dispatch({ type: 'SET_RESOLUTION', payload: { device, size }});

export default {
    setResolution,
};